<template>
  <div class="sidebar-wrapper">
    <el-menu :default-active="defaultActivePath" class="el-menu-vertical" v-if="developerInfo.dev_state !== 1">
      <SidebarItem
        v-for="route of menuList"
        :key="route.name"
        :item="route"
        :base-path="route.path"
      ></SidebarItem>
    </el-menu>
  </div>
</template>

<script>
import SidebarItem from './SidebarItem';
import { mapState } from 'vuex';
const langMap = {
  cn: 0,
  en: 1,
  tw: 2,
  tha: 3,
  esn: 4,
  ptb: 5,
  jpn: 7,
  vie: 10,
  msa: 16
}
const isProd = process.env.VUE_APP_ENV === 'prod';

export default {
  components: {
    SidebarItem,
  },
  mounted() {},
  computed: {
    ...mapState(['routes', 'developerInfo']),
    defaultActivePath() {
      const { path, meta } = this.$route;
      let newPath = path;

      // $vi18n('$i18n# 如果需要特殊的高亮 #i18n$')，$vi18n('$i18n# 例如在 #i18n$') B $vi18n('$i18n# 页面时 #i18n$')，$vi18n('$i18n# 高亮显示 #i18n$') A $vi18n('$i18n# 菜单 #i18n$')。$vi18n('$i18n# 可以在 #i18n$') meta $vi18n('$i18n# 中添加 #i18n$') activePath $vi18n('$i18n# 额外处理 #i18n$')
      if (meta.activePath) {
        // $vi18n('$i18n# 获取根路径 #i18n$')
        const currentRootPath = '/' + path.slice(1).split('/').shift();
        // $vi18n('$i18n# 拼接 #i18n$') activePath
        newPath = [currentRootPath, meta.activePath].join('/');
      }
      return newPath;
    },
    menuList() {
      const lang = localStorage.getItem('current_lang') || sessionStorage.getItem('url_lang') || localStorage.getItem('country_lang')
      console.log(lang)
      const wikiUrl = lang === 'vie' ? 
        'https://wiki.miniworldgame.vn/doku.php?id=developer_center:developer_operation_guide ' : 
        'https://wiki.miniworldgame.com/doku.php?id=developer_center:developer_operation_guide'
      let menuList = [...this.routes];
      this.routes.forEach((e, i) => {
        if (e.name === 'Charts') {
          menuList[i] = {
            path: '/charts/map',
            meta: {
              title: this.$vi18n('$i18n# 数据中心 #i18n$'),
              icon: 'icon-charts',
            },
          };
        }
      });
      menuList = [
        ...menuList,
        {
          path: isProd ? `https://developers.miniworldgame.com/activity/apply-quality-map/index.html?lang=${langMap[lang]}` : `https://developers.miniworldplus.com/activity/apply-quality-map/index.html?lang=${langMap[lang]}`,
          meta: {
            title: '作品申精',
            icon: 'icon-jpal',
          },
          hidden: !(this.developerInfo.dev_state === 3 || this.developerInfo.state === 3)
        },
        {
          path: wikiUrl,
          meta: {
            title: 'WIKI',
            icon: 'icon-wiki',
          },
        },
      ];
      return menuList;
    }
  },
};
</script>

<style lang="scss" scoped>
.el-menu-vertical {
  border-right: none;
}
.el-menu {
  border-radius: 8px;
}
::v-deep .el-menu--inline {
  border-radius: 8px;
}
.sidebar-wrapper {
  width: 200px;
  overflow: hidden;
}
</style>
